import { render } from "./StatsBoard.vue?vue&type=template&id=d430c312"
import script from "./StatsBoard.vue?vue&type=script&lang=js"
export * from "./StatsBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__